<template>
  <div class="inventory-list tab-table p-2">
    <InventoryTable :exclude-search-fields="['receipt']" show-qr-codes-export :showExportAllImages="true"/>
  </div>
</template>


<script>
  import InventoryTable from "../../inventory/InventoryTable";
  import {createNamespacedHelpers} from "vuex";

  const {mapState} = createNamespacedHelpers('receipts');
  const {mapActions: inventoryMapActions} = createNamespacedHelpers('inventory');

  export default {
    name: "InventoryList",
    components: {InventoryTable},
    computed: {
      ...mapState({
        receipt: state => state.view.currentReceipt
      })
    },
    methods: {
      ...inventoryMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'receipt',
        extraFilters: {
          receipt_uuid: this.receipt.uuid
        }
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>
